import React from 'react';
import { HeaderType } from '../components/Title';
import { MenuItem } from '../components/Menu';
import { FaHistory } from "react-icons/fa";
import { useAuth } from '../auth/AuthProvider';
import { useEffect } from 'react';
import * as API from '../services/API';
import { CardEntrada, EntradaType, RecargaType, CardRecarga } from '../components/Card';
import { ScrollPanel } from 'primereact/scrollpanel';
export const HistoryHeader = (): HeaderType => {
  return {
    title: 'Histórico',
    subtitle: `Olá ${useAuth().profile?.nome?.split(' ')[0]}`,
    icon: <FaHistory size={40} />
  }
}

export const HistoryMenu = (): MenuItem => {
  return {
    icon: <FaHistory size={32} />,
    label: 'HISTÓRICO'
  }
}

const History: React.FC = () => {
  const authenticator = useAuth()
  const [entradas, setEntradas] = React.useState<EntradaType[]>([])
  const [recargas, setRecargas] = React.useState<RecargaType[]>([])
  const [all, setAll] = React.useState<Array<any>>([])
  const loadEntradas = async () => {
    try {
      const data = await API.getEntradas(authenticator.token)
      setEntradas(data)
      console.log(data)
    } catch (error) {
      console.error('Erro ao obter entradas:', error)
    }
  }
  const loadRecargas = async () => {
    try {
      const data = await API.getRecargas(authenticator.token)
      setRecargas(data)
      console.log(data)
    } catch (error) {
      console.error('Erro ao obter recargas:', error)
    }
  }

  useEffect(() => {
    if (authenticator.token) {
      loadEntradas()
      loadRecargas()
    }
  }, [])
  useEffect(() => {
    const todasEntradas = [...entradas, ...recargas]
    todasEntradas.sort((a, b) => new Date(b.data).getTime() - new Date(a.data).getTime())
    setAll(todasEntradas)
  }, [entradas, recargas])
  return (
      <ScrollPanel style={{ width: '100%', height: 250 }}>
        {all.map((a, index) => {
          if (a.energia)
            return <CardRecarga key={index} {...a} />
          else
            return <CardEntrada key={index} {...a} />
        }
        )}
      </ScrollPanel>
  );
};

export default History;